import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import Layout from '../../pages/layout';
import ConfigurationRules from '../../pages/ConfigurationRules';

import NotFound from '../../pages/NotFound';
import Integrations from '../../pages/Integrations';
import Landing from '../../pages/Landing';
import { Orders } from '../../pages/Orders';
import { OrderDetails } from '../../pages/Orders/OrderDetails';
import OrderList from '../../pages/Orders/OrderList';
import Profile from '../../pages/Profile';
import { PublicOrderCreation } from '../../pages/PublicOrderCreation';
import { PublicSelectReturnLocation } from '../../pages/PublicSelectReturnLocation';
import DevolutionPageConfig from '../../pages/DevolutionPageConfig';
import { RoutesMapping } from './routesMapping';
import ProtectedRoute from '../auth/protectedRoute';
import Emails from '../../pages/Emails';
import EmailConfigurations from '../../pages/Emails/components/EmailConfigurations';
import InternalServerError from '../../pages/InternalServerError';
import Dashboard from '../../pages/Dashboard';

/**
 * As soon as the landing page is created, we must change the routing logic
 *
 * The landing page will be the default route '/'
 * We will have the public order creation route strictly as /c/:storeNameId
 * All protected environment routes will be under /admin
 */
export default function MyRoutes() {
  return (
    <Routes>
      {/* Public layer routes -> No auth needed */}
      {/* {[RoutesMapping.NOT_FOUND_ROUTE, RoutesMapping.NOT_FOUND].map(
        (path, index) => (
          <Route path={path} element={<NotFound />} key={index} />
        ),
      )} */}
      <Route path={RoutesMapping.NOT_FOUND_ROUTE} element={<NotFound />} />
      <Route
        path={RoutesMapping.INTERNAL_SERVER_ERROR}
        element={<InternalServerError />}
      />
      <Route path={RoutesMapping.LANDING} element={<Landing />} />
      {[
        RoutesMapping.CREATE_PUBLIC_ORDER,
        RoutesMapping.CREATE_PUBLIC_ORDER2,
        RoutesMapping.CREATE_PUBLIC_ORDER3,
        RoutesMapping.CREATE_PUBLIC_ORDER4,
      ].map((path, index) => (
        <Route
          path={path}
          exact
          element={<PublicOrderCreation />}
          key={index}
        />
      ))}
      <Route
        path={`${RoutesMapping.SELECT_RETURN_METHOD}`}
        exact
        element={<PublicSelectReturnLocation />}
      />

      {/* Admin layer routes -> Auth nedded */}
      <Route
        path=""
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path={RoutesMapping.HOME} element={<Dashboard />} />

        <Route path={RoutesMapping.ORDERS} element={<Orders />}>
          <Route path={RoutesMapping.ORDERS_LIST} element={<OrderList />} />
          <Route
            path={RoutesMapping.ORDERS_DETAILS}
            element={<OrderDetails />}
          />
        </Route>

        <Route path={RoutesMapping.PROFILE} element={<Profile />} />

        <Route
          path={RoutesMapping.CONFIGURATION_RULES}
          element={<ConfigurationRules />}
        />

        <Route path={RoutesMapping.INTEGRATIONS} element={<Integrations />} />

        <Route
          path={RoutesMapping.DEVOLUTION_PAGE_COFIGS}
          element={<DevolutionPageConfig />}
        />

        <Route path={RoutesMapping.EMAILS}>
          <Route index={true} element={<Emails />} />
          <Route
            path={RoutesMapping.SELECT_RETURN_METHOD_EMAIL}
            element={<EmailConfigurations type="select-return-method" />}
          />
          <Route
            path={RoutesMapping.CLIQUERETIRE_APPROVED_EMAIL}
            element={<EmailConfigurations type="cliqueretire-approved" />}
          />
          <Route
            path={RoutesMapping.CORREIOS_APPROVED_EMAIL}
            element={<EmailConfigurations type="correios-approved" />}
          />
        </Route>
      </Route>
    </Routes>
  );
}
